import { ReplaySubject } from 'rxjs';

import {
  AnyBlueconicEvent,
  BlueconicPaywallEvent,
  BlueconicStickyBannerBottomEvent,
} from './eventsInterfaces';

export const paywallSubject = new ReplaySubject<BlueconicPaywallEvent>(1);
export const stickyBannerBottomSubject = new ReplaySubject<BlueconicStickyBannerBottomEvent>(1);
export const modalSubject = new ReplaySubject<AnyBlueconicEvent>(1);

export const BLUECONIC = 'blueconic';
export const BlueconicClickEvent = 'CLICK';
